import API from './api';
import { router } from '../routes/routes';
import { dialog } from '../scripts/confirm';
import { toast } from '../scripts/toast';
import { Base64 } from '../scripts/base64';
import * as types from './mutation-types';

import Vue from 'vue';
window.App = new Vue;

// ---- STATES ----

export const addStates = ({ dispatch }) => {
	API.States.get(states => {
		dispatch(types.ADD_STATES, states);
	});
}

export const addCities = ({ dispatch }, state) => {
	API.States.getCities(state, cities => {
		dispatch(types.ADD_CITIES, cities);
	});
}

// ---- PRODUCTS ----

export const getAllProducts = ({ dispatch }) => {
	API.Products.get(1, products => {
		dispatch(types.ADD_PRODUCTS, products.filter(p => p.category));
	});
}

export const createProduct = ({ dispatch }, admin, product, form) => {
	API.Products.create(admin, product, form, product => {
		dispatch(types.ADD_PRODUCT, product);
	});
}

export const setCurrentProduct = ({ dispatch }, id) => {
	API.Products.getById(id, product => {
		dispatch(types.SET_CURRENT_PRODUCT, product);

		if (!product.complements) {
			API.Products.getFullById(product.id, product => {
				dispatch(types.SET_CURRENT_PRODUCT, product);
			});
		}
	});
}

export const setCurrentProductVariation = ({ dispatch }, size) => {
	dispatch(types.SET_PRODUCT_VARIATION, size);
}

export const setCurrentProductEdit = ({ dispatch }, id) => {
	API.Products.getById(id, product => {
		dispatch(types.SET_CURRENT_PRODUCT_EDIT, product);
	});
}

export const removeProduct = ({ dispatch }, admin, product) => {
	API.Products.delete(admin, product, product => {
		dispatch(types.REMOVE_PRODUCT, product);
	});
}

export const updateProduct = ({ dispatch }, admin, product, form) => {
	API.Products.update(admin, product, form, product => {
		dispatch(types.UPDATE_PRODUCT, product);
	});
}

export const getCurrentProductRatings = ({ dispatch }, product_id) => {
	API.Products.ratings(product_id, ratings => {
		dispatch(types.SET_CURRENT_PRODUCT_RATINGS, ratings);
	});
}

export const checkPurchasePaid = ({ dispatch }, user, order) => {
	API.Orders.checkPaid(user, order, res => {
		// console.log(res);
	});
}

export const changeDeliveredStatus = ({ dispatch }, user, delivered) => {
	API.Orders.delivered(user, delivered, res => {
		// console.log(res);
	});
}

export const setCurrentProductParent = ({ dispatch }, product_id) => {
	API.Products.parent(product_id, parent => {
		dispatch(types.SET_CURRENT_PRODUCT_PARENT, parent);
	});
}

export const resetCurrentProductParent = ({ dispatch }) => {
	dispatch(types.RESET_CURRENT_PRODUCT_PARENT);
}

export const setRandomProducts = ({ dispatch }, id) => {
	API.Products.random(id, products => {
		dispatch(types.SET_RANDOMS, products);
	});
}

export const resetRandomProducts = ({ dispatch }) => {
	dispatch(types.RESET_RANDOMS);
}

export const setFeaturedProducts = ({ dispatch }) => {
	API.Products.featured(products => {
		dispatch(types.SET_FEATUREDS, products);
	});
}

export const setSpecialProducts = ({ dispatch }) => {
	API.Products.special(products => {
		dispatch(types.SET_SPECIALS, products);
	});
}

export const setNewProducts = ({ dispatch }) => {
	API.Products.new(products => {
		dispatch(types.SET_NEWS, products);
	});
}

// ---- SHOPPING CART ----

export const getShoppingCart = ({ dispatch }, user) => {
	API.ShoppingCart.get(user, shopping_cart => {
		dispatch(types.SET_SHOPPING_CART, shopping_cart);
	});
}

export const addProductShoppingCart = ({ dispatch }, user, product, quantity = 1, variation = 'M') => {
	if (!user.token) {
		// get the products of the shopping cart, if they are not products set an empty array.
		let products = JSON.parse(localStorage.getItem('lasddi_shopping_cart')) || [];
		let already_exists = false;
		// check if the product already exists in the store.
		for (let i = 0, p = products; i < p.length; i++) {
			if (p[i].product.id == product.id && p[i].variation == variation) {
				already_exists = true;
				p[i].quantity = parseInt(quantity) + parseInt(p[i].quantity);
			}
		}
		// push the products.
		if (!already_exists) {
			products.push({ product: product, quantity: quantity, variation: variation });
		}

		toast({
			title: 'Carrito de Compras',
			content: `El producto ${ product.name } ha sido agregado.`
		});
		// set the item.
		localStorage.setItem('lasddi_shopping_cart', JSON.stringify(products));
		window.App.$emit('show-recently-added');
		return dispatch(types.ADD_LOCAL_SHOPPING_CART, product, quantity, variation);
	}

	API.ShoppingCart.addProduct(user, product, quantity, variation, shopping_cart => {
		dispatch(types.SET_SHOPPING_CART, shopping_cart);
		window.App.$emit('show-recently-added');
	});
}

export const removeProductShoppingCart = ({ dispatch }, user, product) => {
	if (!user.token) {
		// get the products of the shopping cart, if they are not products set an empty array.
		let products = JSON.parse(localStorage.getItem('lasddi_shopping_cart'));
		// check if the product already exists in the store.
		for (let i = 0; i < products.length; i++) {
			if (products[i].product.id == product.product.id) {
				products.splice(i, 1);
			}
		}

		toast({
			title: 'Carrito de Compras',
			content: `El producto ${ product.product.name } ha sido removido.`
		});
		// set the item.
		localStorage.setItem('lasddi_shopping_cart', JSON.stringify(products));
		return dispatch(types.REMOVE_LOCAL_SHOPPING_CART, product);
	}

	API.ShoppingCart.removeProduct(user, product, shopping_cart => {
		dispatch(types.SET_SHOPPING_CART, shopping_cart);
	});
}

export const checkoutShoppingCart = ({ dispatch }, user, params, form) => {
	API.ShoppingCart.checkout(user, params, form, html => {
		dispatch(types.GET_HTML, html);
	});
}

export const updateShoppingCart = ({ dispatch }, user, products) => {
	API.ShoppingCart.update(user, products, shopping_cart => {
		dispatch(types.SET_SHOPPING_CART, shopping_cart);
	});
}

export const setAddressShoppingCart = ({ dispatch }, address) => {
	dispatch(types.SET_SHOPPING_ADDRESS, address);
}

export const resetAddressShoppingCart = ({ dispatch }) => {
	dispatch(types.RESET_SHOPPING_ADDRESS);
}

export const setShippingShoppingCart = ({ dispatch }, shipping) => {
	dispatch(types.SET_SHOPPING_SHIPPING, shipping);
}

export const setPaymentShoppingCart = ({ dispatch }, payment) => {
	dispatch(types.SET_SHOPPING_PAYMENT, payment);
}

export const setShoppingCartIndex = ({ dispatch }, index) => {
	dispatch(types.SET_SHOPPING_INDEX, index);
}

// ---- USERS ----

export const setProfileUser = ({ dispatch }, data, id) => {
	API.Users.getById(data, id, user => {
		dispatch(types.SET_PROFILE_USER, user);
	});
}

export const getUsers = ({ dispatch }, data) => {
	API.Users.get(1, data, users => {
		dispatch(types.ADD_USERS, users);
	});
}

export const createUser = ({ dispatch }, user, form) => {
	API.Users.create(user, form);
}

export const deleteUser = ({ dispatch }, admin, user) => {
	API.Users.delete(admin, user, user => {
		dispatch(types.DELETE_USER, user);
	});
}

export const updateUser = ({ dispatch }, admin, user) => {
	API.Users.update(admin, user, user => {
		dispatch(types.UPDATE_USER, user);
	});
}

export const updateMe = ({ dispatch }, user) => {
	API.Users.updateMe(user, user => {
		dispatch(types.UPDATE_ME, user);
	});
}

export const loginUser = ({ dispatch }, user, path) => {
	let storage_user = JSON.parse(localStorage.getItem('lasddi'));

	if (storage_user) {
		return API.Users.me(storage_user, user => {
			storage_user.user = user;
			let data = storage_user;
			dispatch(types.SET_CURRENT_USER, data);
		});
	}

	if (user) {
		let encode = btoa(unescape(encodeURIComponent(user.email + ':' + user.password)));
		return login(dispatch, encode, path);
	}

	if (!user) {
		// wrapp the shopping cart products.
		let shopping_cart = {};
		shopping_cart.products = JSON.parse(localStorage.getItem('lasddi_shopping_cart'));
		// set the shopping cart from the local storage.
		dispatch(types.SET_SHOPPING_CART, shopping_cart);
	}
}

/* Login the user, if this is logged from login view send to carrito de compra. */
function login (dispatch, encode, path) {
	API.Users.login(encode, (user, encode) => {
		user.api_token = encode;

		localStorage.setItem('lasddi', JSON.stringify({
			api_token: user.api_token,
			token: user.token,
			user_type: user.user.user_type
		}));

		let products = JSON.parse(localStorage.getItem('lasddi_shopping_cart')) || [];
		// check if are products in local storage.
		if (products.length) {
			let shopping_cart = {};
			shopping_cart.product_ids = [];
			shopping_cart.quantities = [];
			// extract the ids and quantities by product.
			for (let i = 0, p = products; i < p.length; i++) {
				shopping_cart.product_ids.push(p[i].product.id);
				shopping_cart.quantities.push(p[i].quantity);
			}
			// add the new products.
			API.ShoppingCart.addProducts(user, shopping_cart, new_shopping_cart => {
				localStorage.removeItem('lasddi_shopping_cart');
				dispatch(types.SET_SHOPPING_CART, new_shopping_cart);
			});
		}

		dispatch(types.SET_CURRENT_USER, user);

		if (path) {
			router.go(path);
		}
	});
}

export const logoutUser = ({ dispatch }, path) => {
	localStorage.removeItem('lasddi');
	dispatch(types.UNSET_CURRENT_USER);

	if (path) {
		router.go(path);
	}
}

export const verifyAccount = ({ dispatch }, token) => {
	API.Users.verify(token);
}

export const addRating = ({ dispatch }, user, rating) => {
	API.Users.rate(user, rating, comment => {
		dispatch(types.ADD_RATE, comment);
	});
}

// ---- WISH LIST ----

export const getWishList = ({ dispatch }, user) => {
	API.WishList.get(user, wish_list => {
		dispatch(types.SET_WISH_LIST, wish_list.data);
	});
}

export const addProductWishList = ({ dispatch }, user, product) => {
	API.WishList.add(user, product, product => {
		dispatch(types.ADD_PRODUCT_WISH_LIST, product);
	});
}

export const removeProductWishList = ({ dispatch }, user, product) => {
	API.WishList.remove(user, product, (res) => {
		dispatch(types.REMOVE_PRODUCT_WISH_LIST, product);
	});
}

// ---- BILLING INFO ----

export const setBillingInfo = ({ dispatch }, user) => {
	API.BillingInfo.get(user, billing_info => {
		dispatch(types.SET_BILLING_INFO, billing_info);

		for (let i = 0, b = billing_info; i < b.length; i++)
			if (b[i].rfc)
				return dispatch(types.SET_RFC_BILLING_INFO, b[i]);

		dispatch(types.SET_RFC_BILLING_INFO, {});
	});
}

export const addBillingInfo = ({ dispatch }, user, info, options) => {
	API.BillingInfo.add(user, info, options, billing_info => {
		dispatch(types.ADD_BILLING_INFO, billing_info);
	});
}

export const removeBillingInfo = ({ dispatch }, user, info) => {
	API.BillingInfo.remove(user, info, billing_info => {
		dispatch(types.REMOVE_BILLING_INFO, billing_info);
	});
}

export const updateBillingInfo = ({ dispatch }, user, info, index) => {
	API.BillingInfo.update(user, info, index, billing_info => {
		dispatch(types.UPDATE_BILLING_INFO, billing_info);
	});
}

export const setFedexQuote = ({ dispatch }, user, index, product_id) => {
	API.BillingInfo.quote(user, index, product_id, quote => {
		dispatch(types.SET_FEDEX_QUOTE, quote);
	});
}

export const resetFedexQuote = ({ dispatch }) => {
	dispatch(types.RESET_FEDEX_QUOTE);
}

export const setNationalQuote = ({ dispatch }, user, index) => {
	API.BillingInfo.quoteNational(user, index, quote_national => {
		dispatch(types.SET_NATIONAL_QUOTE, quote_national);
	});
}

export const resetNationalQuote = ({ dispatch }) => {
	dispatch(types.RESET_NATIONAL_QUOTE);
}

// ---- SEARCH ----

export const search = ({ dispatch }, query) => {
	API.Search.search(query, results => {
		dispatch(types.SET_RESULTS, results);
	});
}

// ---- ORDER ----

export const getOrders = ({ dispatch }, user ) => {
	API.Orders.get(1, user, orders => {
		dispatch(types.GET_ORDERS, orders);
	});
}

export const deleteOrder = ({ dispatch }) => {
		API.Orders.delete(admin, order, order  => {
		dispatch(types.DELETE_ORDER, order);
	});
}

export const getUserOrders = ({ dispatch }, user) => {
	API.Orders.getMe(user, orders => {
		// console.log(orders);
	});
}

export const getUserPurchaseOrders = ({ dispatch }, user) => {
	API.Orders.getMePurchase(user, purchase_orders => {
		dispatch(types.ADD_USER_PURCHASE_ORDERS, purchase_orders);
	});
}

// ---- Slider ----

export const getSliders = ({ dispatch }, user ) => {
	API.Sliders.get(1, user, sliders => {
		dispatch(types.GET_SLIDERS, sliders);
	});
}

export const deleteSlider  = ({ dispatch }, admin, slider) => {
	API.Sliders.delete(admin, slider, slider => {
		dispatch(types.DELETE_SLIDER, slider);
	});
}

export const addNewSlider  = ({ dispatch }, slider, user, component) => {
	API.Sliders.create(slider, user, component).then(slider => {
		dispatch(types.ADD_NEW_SLIDER, slider);
	});
}

export const getDisplaySliders = ({ dispatch }) => {
	API.Sliders.getDisplay(sliders => {
		dispatch(types.GET_PUBLIC_SLIDERS, sliders);
	});
}

export const moveSlider = ({ dispatch }, user, pos1, pos2) => {
	API.Sliders.move(user, pos1, pos2);
}

// ---- CATEGORIES ----

export const getCategories = ({ dispatch }) => {
	API.Categories.get(categories => {
		dispatch(types.GET_CATEGORIES, categories);
	});
}

export const setCurrentCategory = ({ dispatch }, category) => {
	dispatch(types.SET_CURRENT_CATEGORY, category);
}

// ---- CONTRACT PROJECTS ----

export const getContractProjects = ({ dispatch }, user) => {
	API.Projects.get(1, user, projects => {
		dispatch(types.GET_CONTRACT_PROJECTS, projects);
	});
}

export const getDisplayProjects = ({ dispatch }, user) => {
	API.Projects.getDisplay(1, projects => {
		dispatch(types.GET_PUBLIC_PROJECTS, projects);
	});
}

export const setCurrentProject = ({ dispatch }, id) => {
	API.Projects.getById(id, project => {
		dispatch(types.SET_CURRENT_PROJECT, project);

		if (!project.products) {
			API.Projects.getFullById(id, project => {
				dispatch(types.SET_CURRENT_PROJECT, project);
			});
		}
	});
}

export const addContractProject = ({ dispatch }, admin, project, form) => {
	API.Projects.create(admin, project, form, project => {
		dispatch(types.ADD_CONTRACT_PROJECT, project);
	});
}

export const removeContractProject = ({ dispatch }, admin, project) => {
	API.Projects.delete(admin, project, project => {
		dispatch(types.DELETE_CONTRACT_PROJECT, project);
	});
}

export const moveProject = ({ dispatch }, user, pos1, pos2) => {
	API.Projects.move(user, pos1, pos2);
}

// ---- PROMO CODES ----

export const applyPublicCode = ({ dispatch }, user, code, product_has_promo) => {
	API.PromoCodes.applyPublic(user, code, product_has_promo, code_info => {
		dispatch(types.SET_PROMO_CODE, code_info);
	});
}

// ---- FILTERS ----

export const filterPrice = ({ dispatch }, min, max) => {
	dispatch(types.SET_FILTER_PRICE, min, max);
}

export const filterSub = ({ dispatch }, sub) => {
	dispatch(types.SET_FILTER_SUBCATEGORY, sub);
}

export const filterColor = ({ dispatch }, color) => {
	dispatch(types.SET_FILTER_COLOR, color);
}

// ---- NEWSLETTER ----

export const subscribeNewsletter = ({ dispatch }, email) => {
	API.Newsletter.subscribe(email);
}

// ---- PRICE ----

export const resetFilterPrice = ({ dispatch }) => {
	dispatch(types.RESET_FILTER_PRICE);
}

// ---- COLORS ----

export const getColors = ({ dispatch }, cat) => {
	API.Colors.get(cat, colors => {
		dispatch(types.SET_COLORS, colors);
	});
}

export const resetColors = ({ dispatch }) => {
	dispatch(types.RESET_COLORS);
}

// ---- NOTIFY STOCK ----

export const notifyMe = ({ dispatch }, user, product, email) => {
	API.Products.notify(user, product, res => {
		toast({
			title: 'Enviado Correctamente',
			content: 'Seras informado por correo cuando se tengan existencias del producto.'
		});
	}, email);
}

// ---- SELECTIONS ----

export const getSelections = ({ dispatch }, selection) => new Promise((resolve, reject) => {
	API.Selections.getByAlias(selection, res => {
		resolve(res)
	}, err => reject(err))
})



// WEBPACK FOOTER //
// ./src/store/actions.js